import { useState } from "react";
import { Colors } from "../constants";

export default () => {
  let [ modal, setModal ] = useState(false);
  let [ modalContent, setModalContent ] = useState("I'm the Modal Content");
  let [ modalTitle, setModalTitle ] = useState();
  let [ modalSubmitCallback, setModalSubmitCallback ] = useState(undefined);
  let [ textButton, setTextButton ] = useState({ cancel: 'Cancel', submit: 'Submit' });
  let [ customColor, setCustomColor ] = useState(`#${Colors.primaryColor}`);
  let [ info, setInfo ] = useState(false);

  let handleModal = (title = false, content = false, submitCallback = false, textButton = false, show = false, customColor = false, info) => {
    if(show){
      setModal(show)
    }
    else{
      setModal(!modal);
    }


    if (content) {
      setModalContent(content);
    }
    if(title){
      setModalTitle(title);
    }
    if(submitCallback){
      setModalSubmitCallback(() => submitCallback)
    }
    if(textButton){
      setTextButton(textButton);
    }

    if(customColor){
      setCustomColor(customColor);
    }
    else{
      setCustomColor(`#${Colors.primaryColor}`);
    }

    if (info) {
      setInfo(info)
    }
  };

  let hideModal = () => {
    setModal(false);
  }
  return { modal, handleModal, modalContent, modalTitle, modalSubmitCallback, textButton, hideModal, customColor, info };
};
